<div id="sku-component" style="height: 100%; width: 22vw">
  <mat-tab-group
    class="sku_new sku-mat-tab-group"
    animationDuration="0ms"
    scrollDistance="180"
    [selectedIndex]="1"
    style="height: calc(100% - 70px)"
  >
    <mat-tab label="">
      <div
        style="
          position: sticky;
          z-index: 1;
          top: 0;
          background-color: white;
          padding-top: 3vh;
        "
      >
        <div style="display: flex; justify-content: center">
          <button
            class="browse-sku-button"
            (click)="changeLabel('browse sku')"
            [ngClass]="
              selectedLabel === 'browse sku' ? 'selected-sku-button' : ''
            "
            mat-flat-button
          >
            <span>Browse SKU</span>
            <mat-icon style="font-size: 14px; top: 1px; margin: 0"
              >lock</mat-icon
            >
          </button>
          <button
            class="assortment-list-button"
            (click)="changeLabel('assortment')"
            [ngClass]="
              selectedLabel === 'assortment' ? 'selected-sku-button' : ''
            "
            mat-flat-button
          >
            Assortment
          </button>
        </div>
        <div
          style="
            display: flex;
            justify-content: center;
            align-items: center;
            padding: 10px;
            font-size: 0.9vw;
            border-bottom: 1px solid #c2c8d0;
          "
        >
          <mat-form-field
            style="width: 100%"
            appearance="outline"
            class="sku-search-input"
          >
            <mat-icon matPrefix>search</mat-icon>
            <input
              matInput
              [(ngModel)]="sku_search_input"
              [value]="sku_search_input"
              type="text"
              placeholder="Search"
              (change)="filterSkuBasedOnSearch($event)"
            />
          </mat-form-field>
        </div>
      </div>
      <div style="overflow-y: auto; height: calc(100% - 150px)">
        <div *ngIf="selectedLabel === 'browse sku'">
          <mat-list
            cdkDropList
            [cdkDropListConnectedTo]="drop_item_ids"
            id="subjectList"
          >
            <mat-list-item
              cdkDrag
              (cdkDragStarted)="dragStart($event)"
              (cdkDragMoved)="moved($event)"
              [cdkDragData]="sku"
              *ngFor="let sku of search_filtered_sku_list; let i = index"
              class="no-padding sku-list-item"
            >
              <div style="display: flex; gap: 30px">
                <div *ngIf="sku.loading" class="loader">
                  <mat-spinner diameter="24"></mat-spinner>
                </div>
                <img
                  *ngIf="!sku.loading"
                  [ngStyle]="{
                    'height.vh': (sku.height * 0.5) / 8,
                    'width.vh': (sku.diameter * 0.5) / 8,
                    'border-radius': 10
                  }"
                  [src]="sku.blob_img_uri"
                />
                <div>
                  <h3 style="font-size: 1vw; font-weight: bold" mat-line>
                    {{ sku.brand_inswa }}
                  </h3>
                  <p style="font-size: 0.9vw" mat-line>
                    <span>{{ sku.pack_size_revised }}ml </span>
                  </p>
                  <span
                    mat-line
                    style="
                      color: red;
                      text-align: right;
                      font-size: 21px;
                      padding-top: 2px;
                    "
                  >
                    <!-- <em
                      class="bi bi-info-circle"
                      style="margin-right: 10px; cursor: pointer"
                      (click)="showSKUInformation(sku)"
                    ></em> -->
                  </span>
                </div>
              </div>
            </mat-list-item>
          </mat-list>
          <div
            style="display: flex; justify-content: center; margin-top: 3vw"
            *ngIf="search_message.length !== 0"
          >
            {{ search_message }}
          </div>
        </div>
        <div
          [ngStyle]="{ opacity: isReset ? '0.3' : '1' }"
          *ngIf="selectedLabel === 'assortment'"
        >
          <table class="assortment-table">
            <thead>
              <tr>
                <th>Product Added</th>
                <th>Shelf</th>
                <th>Facings</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let sku of assortment_table_data">
                <td style="font-weight: bold">{{ sku.sku_face }}</td>
                <td>{{ sku.shelf_type }}</td>
                <td>{{ sku.total_final_facings }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </mat-tab>
  </mat-tab-group>
</div>
